<template>
    <div
        class="refund-request-checkbox ot-checkbox"
        :disabled="disabled"
        :class="{ 'ot-highlight': selected, disabled }"
    >
        <!--suppress HtmlFormInputWithoutLabel -->
        <input
            :id="`refund-request-checkbox_${guid}`"
            type="checkbox"
            :checked="selected"
            :disabled="disabled"
            @click="onInput($event)"
        >
        <label
            class="ot-checkbox-label refund-request-checkbox__label"
            :for="`refund-request-checkbox_${guid}`"
        >
            <slot />
        </label>
    </div>
</template>

<script setup lang="ts">
interface Props {
    guid: string;
    selected: boolean;
    disabled: boolean;
}

type Emits = {
    (e: 'input', value: boolean): void;
};

withDefaults(defineProps<Props>(), {
    selected: false,
    disabled: false,
});

const emit = defineEmits<Emits>();

const onInput = (event: Event): void => {
    // TODO: https://app.clickup.com/t/86c2qmj0w
    if (event.target && event.target instanceof HTMLInputElement) {
        const { target } = event;
        emit('input', target.checked);
    }
};
</script>

<style lang="scss" scoped>
.refund-request-checkbox {
    box-sizing: border-box;

    border: 1.5px solid var(--ot-shop-color-box-outline-dropdown);
    box-shadow: 0 2px 4px -2px var(--ot-shop-color-box-dropdown);
    border-radius: 0.375rem;

    &:not(:last-child) {
        margin: 0.5rem 0;
    }

    &.ot-highlight.disabled {
        box-shadow: 0 0 0 2px var(--ot-input-color-disabled-invert),
            0 0 0 4px var(--ot-color-core-brand-faded) !important;
    }
}
</style>
